export enum Gender {
    BOY = "Boy",
    GIRL = "Girl",
}
